import React, { useState, useMemo } from 'react'

import {
  Grid, Button, Fab, Typography, Tooltip, Paper, Fade,
  // MenuItem, Chip, Select, InputLabel,
  TableCell, TableRow, Input, FormControl, TextField, IconButton, Popper,
  Dialog, DialogTitle, DialogContent, DialogActions,
  List, ListItem, ListItemText
} from '@material-ui/core'

import { makeStyles, withStyles } from '@material-ui/core/styles'

import TreeView from '@material-ui/lab/TreeView'
import UnitTree from '../../tools/UnitTree'

import EditIcon from '@material-ui/icons/Edit'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'
import AccountTree from '@material-ui/icons/AccountTree'
import StyleIcon from '@material-ui/icons/Style'
import CloseIcon from '@material-ui/icons/Close'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'

import { truncateText, ValidatePhone, ValidateEmail, keyify2 } from '../../../../utils'

import { PhoneMask, EmailMask } from '../../tools/TextMasks'

import { useSelector } from 'react-redux'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '10em',
    maxWidth: '10em'
  },
  singleChip: {
    width: '85%'
  },
  cssUnderline: {
    marginBottom: 'auto',
    marginTop: 'auto',
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  cssLabel: {
    width: '100%',
    '&$cssFocused': {
      color: '#A4D164',
      width: '100%'
    }
  },
  cssFocused: {
  },
  editBtn: {
    backgroundColor: '#719E31',
    color: '#fff',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    '&:hover': {
      backgroundColor: '#3E6B00',
      color: '#fff'
    }
  },
  warningEditBtn: {
    backgroundColor: '#f0ad4e',
    color: '#fff',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    '&:hover': {
      backgroundColor: '#BD7A1B',
      color: '#fff'
    }
  },
  saveBtn: {
    backgroundColor: '#0651C4',
    color: '#fff',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    '&:hover': {
      backgroundColor: '#0038AB',
      color: '#fff'
    }
  },
  deleteBtn: {
    backgroundColor: '#D9534F',
    color: '#fff',
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    '&:hover': {
      backgroundColor: '#A6201C',
      color: '#fff'
    }
  },
  userExists: {
    backgroundColor: '#D3D3D3'
  },
  userNew: {
    backgroundColor: '#fff'
  },
  ouBtn: {
    // backgroundColor: '#0651C4',
    // color: '#fff',
    paddingLeft: '0.5em',
    paddingRight: '0.5em'
    // '&:hover': {
    //   backgroundColor: '#0038AB',
    //   color: '#fff'
    // }
  },
  roleBtn: {
    paddingLeft: '0.5em',
    paddingRight: '0.5em'
  },
  errorLight: {
    backgroundColor: '#f0ad4e',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#BD7A1B'
    }
  },
  successLight: {
    backgroundColor: '#719E31',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#3E6B00',
      color: '#fff'
    }
  },
  roleTitle: {
  },
  selectedRole: {
    color: '#719E31'
  },
  unselectedRole: {
    color: theme.palette.text.secondary
  },
  rolePopper: {
    zIndex: '1051 !important',
    marginBottom: theme.spacing(1)
  },
  rolePaper: {
    padding: theme.spacing(1)
  },
  unitApplyBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    marginTop: theme.spacing(2)
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    // backgroundColor: '#fff',
    width: '100%'
  },
  focused: {}
}))

const batchErrors = {
  EMAIL_ERROR: 'email-error',
  ENTRY_ERROR: 'entry-error',
  ROLE_ERROR: 'role-error',
  UNIT_ERROR: 'unit-error'
}

const UserMgmtCreate = (props) => {
  const {
    userInfo = {}, editInfo = {},
    onEditUser = () => { }, onConfigChange = () => { },
    onDeleteUser = () => { }, onUserInfoChange = () => { }
  } = props
  const classes = useStyles()
  const textClasses = useTextStyles()

  // const [adminRole, setAdminRole] = useState('')
  const [expandedKeys, setExpandedKeys] = useState([])
  const [roles, setRoles] = useState([])

  const [roleAnchor, setRoleAnchor] = useState(null)
  // const [matchingEmail, setMatchingEmail] = useState('')

  const [openUnits, setOpenUnits] = useState(false)
  const [openRoles, setOpenRoles] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)

  const userRoles = useSelector(state => state.userRoles.userRoles)
  const unitTree = useSelector(state => state.auth.unitTree)

  useMemo(() => { if (userRoles.length) { setRoles(userRoles) } }, [userRoles])

  // useEffect(() => {
  //   if (adminUnits && userInfo.units) {
  //     if (adminUnits.sort() !== userInfo.units.sort()) {
  //       setUserInfo({ ...userInfo, units: adminUnits })
  //     }
  //   }
  // }, [adminUnits, userInfo])

  // useEffect(() => {
  //   if (adminRole !== userInfo.roleID && userRoles.length) {
  //     setUserInfo({ ...userInfo, roleID: adminRole })

  //     const roleIndex = userRoles.findIndex((userRole) => {
  //       return userRole.roleID === adminRole
  //     })

  //     if (roleIndex !== -1 && adminRole !== '') {
  //       setRoleName(userRoles[roleIndex].roleName)
  //     } else {
  //       setRoleName('')
  //     }
  //   }
  // }, [adminRole, userInfo, userRoles])

  // useEffect(() => {
  //   if (units) {
  //     if (units.sort() !== userInfo.units.sort()) {
  //       setUserInfo({ ...userInfo, units })
  //     }
  //   }
  // }, [units, userInfo])

  const handleSave = () => {
    const newUserInfo = {
      ...userInfo.enableEditing ? editInfo : userInfo,
      enableEditing: false
    }
    onConfigChange(newUserInfo)
  }

  const handleRoleChange = (roleID) => {
    const newUserInfo = {
      ...userInfo.enableEditing ? editInfo : userInfo,
      roleID
    }

    onConfigChange(newUserInfo)
  }

  const handleRoleApply = () => {
    setOpenRoles(false)
  }

  const manageUnits = () => {
    setOpenUnits(true)

    const unitKeys = keyify2(unitTree)
    setExpandedKeys(unitKeys)
  }

  const handleUnitClick = (ancestors, key, isSelected, children) => {
    if (!isSelected) {
      const unitsToAdd = []
      let selection = []

      if (!ancestors.length) {
        selection = [key, ...keyify2(children)]
      } else {
        selection = [...ancestors, key, ...keyify2(children)]
      }

      selection.forEach((selectedKey) => {
        if (userInfo.units.findIndex((assignedUnit) => assignedUnit === selectedKey) === -1) {
          unitsToAdd.push(selectedKey)
        }
      })

      const newUserInfo = {
        ...userInfo.enableEditing ? editInfo : userInfo,
        units: [...userInfo.units, ...unitsToAdd]
      }

      onConfigChange(newUserInfo)
    } else {
      if (ancestors.length) {
        const tempAssigned = [...userInfo.units].filter((assignedUnit) => assignedUnit !== key)
          .filter((assignedUnit) => children.findIndex((childUnit) => childUnit.key === assignedUnit) === -1)

        const newUserInfo = {
          ...userInfo.enableEditing ? editInfo : userInfo,
          units: tempAssigned
        }

        onConfigChange(newUserInfo)
      } else {
        const newUserInfo = {
          ...userInfo.enableEditing ? editInfo : userInfo,
          units: []
        }
        onConfigChange(newUserInfo)
      }
    }
  }

  const handleUnitApply = () => {
    setOpenUnits(false)
  }

  const handleEmailChange = (emailVal) => {
    if (!ValidateEmail(emailVal) && Boolean(emailVal) && !emailError) {
      setEmailError(true)
    } else if (emailError && ValidateEmail(emailVal)) {
      setEmailError(false)
    }

    onUserInfoChange('emailAddress', emailVal)
  }

  const handlePhoneChange = (phoneVal) => {
    if (!ValidatePhone(phoneVal) && Boolean(phoneVal) && !phoneError) {
      setPhoneError(true)
    } else if (phoneError && ValidatePhone(phoneVal)) {
      setPhoneError(false)
    }
    onUserInfoChange('officePhone', phoneVal)
  }

  return (
    <>
      <TableRow className={userInfo.error ? classes.userExists : classes.userNew}>
        <TableCell align='center' className='px-2'>
          {userInfo.enableEditing ? (
            <Grid container direction='row'>
              <Grid container item direction='column' justify='space-between'>
                <Fab size='medium' className={`mb-3 ${classes.saveBtn}`} onClick={handleSave}>
                  <CheckCircleIcon />
                </Fab>
                <Fab size='medium' className={classes.deleteBtn} onClick={() => onDeleteUser(userInfo.userID)}>
                  <DeleteIcon />
                </Fab>
              </Grid>
            </Grid>
          )
            : (
              <Tooltip
                title={
                  userInfo.errorType === batchErrors.ENTRY_ERROR
                    ? 'Fields are empty' : userInfo.errorType === batchErrors.EMAIL_ERROR
                      ? 'User Already Exists!' : userInfo.errorType === batchErrors.ROLE_ERROR
                        ? 'Must Assign a Role!' : userInfo.errorType === batchErrors.UNIT_ERROR
                          ? 'Must Assign a Unit!' : 'Good to go!'
                }
                arrow
                placement='right'
              >
                <Fab
                  size='medium'
                  className={userInfo.errorType ? classes.warningEditBtn : classes.editBtn}
                  onClick={() => onEditUser(userInfo)}
                >
                  {userInfo.errorType === batchErrors.EMAIL_ERROR ? (<WarningIcon />) : userInfo.errorType ? (<ErrorIcon />) : (<EditIcon />)}
                </Fab>
              </Tooltip>
            )}
        </TableCell>

        <TableCell align='center'>
          {userInfo.enableEditing ? (
            <TextField
              value={editInfo.firstName}
              onChange={(e) => onUserInfoChange('firstName', e.target.value)}
              placeholder='First Name'
              required
            />
          )
            : (
              userInfo.firstName
            )}
        </TableCell>

        <TableCell align='center'>
          {userInfo.enableEditing ? (
            <TextField
              value={editInfo.lastName}
              onChange={(e) => onUserInfoChange('lastName', e.target.value)}
              placeholder='Last Name'
              required
            />
          )
            : (
              userInfo.lastName
            )}
        </TableCell>

        <TableCell align='center'>
          {userInfo.enableEditing ? (
            <TextField
              value={editInfo.jobTitle}
              onChange={(e) => onUserInfoChange('jobTitle', e.target.value)}
              placeholder='Job Title'
            />
          )
            : (
              <LightTooltip title={userInfo.jobTitle} placement='top'>
                <Button>{truncateText(userInfo.jobTitle)}</Button>
              </LightTooltip>
            )}
        </TableCell>

        <TableCell align='center'>
          {userInfo.enableEditing ? (
            <FormControl fullWidth>
              <Input
                id='phone-input'
                name='phoneInput'
                value={editInfo.officePhone}
                onChange={(e) => handlePhoneChange(e.target.value)}
                error={phoneError}
                color='primary'
                classes={textClasses}
                fullWidth
                inputComponent={PhoneMask}
              />
            </FormControl>
          )
            : (
              userInfo.officePhone
            )}
        </TableCell>

        <TableCell align='center'>
          {userInfo.enableEditing ? (
            <FormControl fullWidth>
              <Input
                id='email-input'
                name='emailInput'
                value={editInfo.emailAddress}
                onChange={(e) => handleEmailChange(e.target.value)}
                error={emailError}
                color='primary'
                classes={textClasses}
                fullWidth
                inputComponent={EmailMask}
              />
            </FormControl>
          )
            : (
              <LightTooltip title={userInfo.emailAddress} placement='top'>
                <Button>{truncateText(userInfo.emailAddress)}</Button>
              </LightTooltip>
            )}
        </TableCell>

        <TableCell align='center' className='py-0'>
          <Popper open={roleAnchor !== null} placement='top' anchorEl={roleAnchor} transition className={classes.rolePopper}>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps}>
                <Paper elevation={3} className={classes.rolePaper}>
                  <Typography>{userInfo.roleID ? userInfo.roleName : 'No Role'}</Typography>
                </Paper>
              </Fade>
            )}
          </Popper>

          <IconButton
            size='medium'
            className={`${classes.roleBtn} ${userInfo.roleID === '' ? classes.errorLight : classes.successLight}`}
            onClick={() => setOpenRoles(true)}
            onMouseEnter={(e) => setRoleAnchor(e.currentTarget)}
            onMouseLeave={() => setRoleAnchor(null)}
          >
            <StyleIcon />
          </IconButton>
        </TableCell>

        <TableCell align='center' className='py-0'>
          <IconButton
            size='medium'
            className={`${classes.ouBtn} ${!userInfo.units.length ? classes.errorLight : classes.successLight}`}
            onClick={manageUnits}
          >
            <AccountTree />
          </IconButton>
        </TableCell>
        {/* <TableCell>
        <Tooltip title={alreadyExists ? 'User Already Exists!' : 'Good to go!'}>
          <Fab size='small'>
            {alreadyExists ? (<WarningIcon />) : (<ThumbUpIcon />)}
          </Fab>
        </Tooltip>
      </TableCell> */}
      </TableRow>

      <Dialog open={openRoles} scroll='paper' disableBackdropClick disableEscapeKeyDown>
        <DialogTitle disableTypography>
          <Grid container direction='row' className='mx-auto w-100' justify='space-between' alignItems='center'>
            <Grid item>
              <Typography variant='h6' className={`${classes.roleTitle}`}>Select a Role</Typography>
            </Grid>
            <Grid item>
              <IconButton className={classes.closeButton} onClick={() => setOpenRoles(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <List className='w-100' disablePadding>
            {
              roles.map((roleInfo) => {
                const secondaryText = roleInfo.rolePermissions.reduce((arr, permissionInfo) => {
                  arr.push(permissionInfo.permissionDisplayName)
                  return arr
                }, [])

                return (
                  <ListItem button key={`batch-role-${roleInfo.roleID}`} onClick={() => handleRoleChange(roleInfo.roleID)}>
                    <ListItemText
                      primary={
                        <Grid container direction='row' alignItems='center'>
                          <Grid item xs={11}>
                            <Typography variant='body1' component='span' display='block'>
                              {roleInfo.roleName}
                            </Typography>
                          </Grid>

                          <Grid item xs={1} container direction='row' justify='flex-end'>
                            {
                              userInfo.roleID === roleInfo.roleID
                                ? (
                                  <RadioButtonCheckedIcon className={classes.selectedRole} fontSize='default' />
                                ) : (
                                  <RadioButtonUncheckedIcon className={classes.unselectedRole} fontSize='default' />
                                )
                            }
                          </Grid>
                        </Grid>
                      }
                      disableTypography
                      secondary={
                        <Grid container direction='row' alignItems='center'>
                          <Grid item xs={11}>
                            <Typography variant='body2' component='p' display='block' color='textSecondary' className='mt-2'>
                              {secondaryText.join(', ')}
                            </Typography>
                          </Grid>
                        </Grid>
                      }
                    />
                  </ListItem>
                )
              })
            }
          </List>
        </DialogContent>
        <DialogActions>
          <Grid container direction='row' justify='center'>
            <Button
              variant='contained'
              onClick={handleRoleApply}
              className={classes.unitApplyBtn}
            >
              Apply
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog open={openUnits} scroll='paper' disableBackdropClick disableEscapeKeyDown>
        <DialogTitle disableTypography>
          <Grid container direction='row' className='mx-auto w-100' justify='space-between' alignItems='center'>
            <Grid item>
              <Typography variant='h6' className={`${classes.roleTitle}`}>Select Units</Typography>
            </Grid>
            <Grid item>
              <IconButton className={classes.closeButton} onClick={() => setOpenUnits(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent className='pl-1'>
          <Grid container direction='row'>
            <Grid container item direction='column'>

              <Grid container item direction='row' justify='center'>
                <TreeView disableSelection expanded={expandedKeys}>
                  <UnitTree
                    treeData={unitTree}
                    onUnitClick={handleUnitClick}
                    selectedKeys={userInfo.units}
                    isCheckbox
                  />
                </TreeView>
              </Grid>

              <Grid container item direction='row' justify='center' className='ml-2'>
                <Button
                  variant='contained'
                  onClick={handleUnitApply}
                  className={classes.unitApplyBtn}
                >
                  Apply
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default UserMgmtCreate
